'use client'

import { Modal, ScrollArea } from '@mantine/core'
import { FC } from 'react'

import { ScheduleCallForm } from '../ScheduleCallForm'
import classes from './style.module.css'

export const ScheduleCallPopup: FC<{
  opened: boolean
  setOpened: (open: boolean) => void
}> = ({ opened, setOpened }) => {
  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title='Schedule a Call with Partment'
      centered
      radius='md'
      classNames={classes}
    >
      <ScrollArea.Autosize mah='70vh'>
        <ScheduleCallForm />
      </ScrollArea.Autosize>
    </Modal>
  )
}
